import React from 'react';
import styled from 'styled-components';

// Styled Components
const Container = styled.div`
  max-width: 800px;
  margin: 5px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 10px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Paragraph = styled.p`
  color: #555;
  line-height: 1.6;
  margin-bottom: 10px;
`;

// Delivery Policy Component
const DeliveryPolicy = () => {
  return (
    <Container>
      <Title>Delivery Policy</Title>

      <Section>
        <Paragraph>
          a. Colab Kitchen provides food ordering and delivery services by entering into 
          contractual arrangements with restaurant partners ("Restaurant Partners") and Stores 
          (as defined below) on a principal-to-principal basis for the purpose of listing their 
          menu items or the Products (as defined below) for food ordering and delivery by the 
          Customers on the Colab Kitchen Platform.
        </Paragraph>

        <Paragraph>
          b. The Customers can access the menu items or Products listed on the Colab Kitchen 
          Platform and place orders against the Restaurant Partner(s)/Store(s) through Colab 
          Kitchen. Price for each item normally would be between Rs 2/- to Rs 500/-.
        </Paragraph>

        <Paragraph>
          c. Your request to order food and beverages or Products from a Restaurant Partner or 
          a Store page on the Colab Kitchen Platform shall constitute an unconditional and 
          irrevocable authorization issued in favor of Colab Kitchen to place orders for food and 
          beverages or Products against the Restaurant Partner(s)/Store(s) on your behalf.
        </Paragraph>

        <Paragraph>
          d. Delivery of an order placed by you through the Colab Kitchen Platform may either 
          be undertaken directly by the Restaurant Partner or the Store against whom you have 
          placed an order or facilitated by Colab Kitchen through a third party who may be available 
          to provide delivery services to you (“Delivery Partners”). In both these cases, Colab 
          Kitchen is merely acting as an intermediary between you and the Delivery Partners, or 
          you and the Home Restaurant Partner or the Store, as the case may be. Delivery may take 
          5 mins to 2 hrs depending on various factors like traffic, weather, and status of cooks.
        </Paragraph>

        <Paragraph>
          e. The acceptance by a Delivery Partner of undertaking the delivery of your order shall 
          constitute a contract of service under the Consumer Protection Act, 2019 or any successor 
          legislation between you and the Delivery Partner, to which Colab Kitchen is not a party 
          under any applicable law. It is clarified that Colab Kitchen does not provide any delivery 
          or logistics services and only enables the delivery of food and beverages or Products 
          ordered by the Customers through the Colab Kitchen Platform by connecting the Customers 
          with the Delivery Partners or the Restaurant Partners or the Store, as the case may be. 
          Colab Kitchen shall not be liable for any acts or omissions on the part of the Delivery 
          Partner, including deficiency in service, wrong delivery of order, time taken to deliver 
          the order, order package tampering, etc.
        </Paragraph>
      </Section>
    </Container>
  );
};

export default DeliveryPolicy;
